/* Shopify determines the bag price; the shop portions the selected candy. */
(() => {
  const capacities = Object.freeze([227, 454, 907, 1361, 1814, 2268, 2722, 4536]);
  function evaluate(capacity, selections, limits = { min: 1, max: Infinity }) {
    const validCounts = Array.isArray(selections) && selections.length > 0 &&
      selections.every(value => Number.isInteger(value) && value >= 0);
    const count = validCounts ? selections.reduce((total, value) => total + value, 0) : 0;
    // Custom Christmas containers use a marker, not an invented gram weight.
    const validContainer = limits.unlimited === true ? capacity === 1 : capacities.includes(capacity);
    return { valid: validContainer && validCounts &&
      count >= limits.min && count <= limits.max };
  }
  function properties(capacity, selections, names, limits = { min: 1, max: Infinity }, itemNoun = "bag") {
    if (!evaluate(capacity, selections, limits).valid) throw new Error(limits.min === 5 && itemNoun === "bag" ? "Choose exactly 5 candies for your ½ lb bag." : limits.min === 5
      ? `Choose exactly 5 candies for your ${itemNoun}.` : limits.min === 4 && limits.max === 8
      ? "Choose 4 to 8 candies for your Snackle Box." : limits.min === limits.max && limits.min > 1
        ? `Choose exactly ${limits.min} candies for this bag.` : limits.min > 1 ? `${limits.min} candy choices required for this bag.` : "Choose a bag size and at least one candy.");
    const result = { "_Jazzis mix": "custom-selection" };
    let index = 1;
    selections.forEach((quantity, key) => {
      if (!quantity) return;
      const name = names[String(key)];
      if (typeof name !== "string" || !name.trim()) throw new Error("One of your candy choices is no longer available. Please choose again.");
      const label = quantity > 1 ? `${name.slice(0, 150)} × ${quantity}` : name.slice(0, 180);
      result[`${index++}. ${label}`] = "Selected";
    });
    return result;
  }
  globalThis.JazzisMix = Object.freeze({ evaluate, properties, capacities });
})();
